import client from '../httpClient';

const simulatorCSVUploadStatusApi = (receptionId) => {
  return client.get(`/simulator/csv-upload-status/${receptionId}`);
};

export default simulatorCSVUploadStatusApi;
